import React from "react";
import styles from "./InputWithError.module.scss";
import { FloatLabel, FloatLabelInput } from "../FloatLabel/FloatLabel";
import { Icon } from "../../../Icon/Icon";
import { ValidationInputState } from "../../ValidationInputState";

export interface BasicInputWithErrorProps {
  name: string;
  id: string;
  children: FloatLabelInput;
  errorMessageComponent?: JSX.Element | string;
  validationState: ValidationInputState;
}

export interface InputWithErrorProps extends BasicInputWithErrorProps {
  label: string;
  forceLabelRenderAsFocused?: boolean;
}

export const InputWithError: React.FC<
  React.PropsWithChildren<InputWithErrorProps>
> = ({
  name,
  label,
  id,
  children,
  forceLabelRenderAsFocused = false,
  errorMessageComponent,
  validationState = undefined
}) => {
  const validationError = validationState == "error";

  return (
    <div className={styles.inputWithError} data-controlled-input>
      <FloatLabel
        label={label}
        id={id}
        forceFocus={forceLabelRenderAsFocused}
        validationState={validationState}
      >
        {React.cloneElement(children, {
          id: id,
          name: name,
          validationState,
          "aria-invalid": validationError
        })}
      </FloatLabel>
      {validationError && errorMessageComponent && (
        <div className={styles.error}>
          <Icon name="alert" padding={false} className={styles.icon} />
          {errorMessageComponent}
        </div>
      )}
    </div>
  );
};

export const BasicInputWithError: React.FC<
  React.PropsWithChildren<BasicInputWithErrorProps>
> = ({
  name,
  id,
  children,
  errorMessageComponent,
  validationState = undefined
}) => {
  const validationError = validationState == "error";

  return (
    <div className={styles.inputWithError} data-controlled-input>
      {React.cloneElement(children, {
        id: id,
        name: name,
        "aria-invalid": validationError
      })}

      {validationError && errorMessageComponent && (
        <div className={styles.error}>
          <Icon name="alert" padding={false} className={styles.icon} />
          {errorMessageComponent}
        </div>
      )}
    </div>
  );
};
